import React, { useEffect } from 'react'
import globalStyles from '../../../global.less'
import styles from './index.less'
import { setTitleDesc } from '../../../../utils/tools'
import ProtocolUS from './en-US'

const getSty = (str: string) => styles[str]

export default function Protocol() {
  useEffect(() => {
    setTitleDesc('Xiaomi Channel', '小米分销通')
  }, [])

  return (
    <div className={`${globalStyles['container']} ${getSty('protocol')}`}>
     <ProtocolUS />
    </div>
  )
}
